import Lightbox from '../utils/_lightbox'

export default function Lightboxes () {
  const GALLERIES = document.querySelectorAll('.mtt-gallery')
  if (GALLERIES.length > 0) {
    for (let i = 0; i < GALLERIES.length; i++) {
      const GALLERY_LIGHTBOX = new Lightbox(GALLERIES[i].querySelectorAll('.mtt-gallery__image img'))
    }
  }

  const CUSTOMIZE_WIDGETS = document.querySelectorAll('.mtt-customize-widget__group-items')
  if (CUSTOMIZE_WIDGETS.length > 0) {
    for (let i = 0; i < CUSTOMIZE_WIDGETS.length; i++) {
      const CUSTOMIZE_WIDGET = new Lightbox(CUSTOMIZE_WIDGETS[i].querySelectorAll('.mtt-customize-widget__group-item img'))
    }
  }
}
